import { render, staticRenderFns } from "./PractitionerPercentage.vue?vue&type=template&id=aaed86dc&"
import script from "./PractitionerPercentage.vue?vue&type=script&lang=js&"
export * from "./PractitionerPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports